import type { MiaSession } from '../types';

const KEY = 'mia_widget_session_v1';

/**
 * Ephemeral session persistence for the browser tab only.
 * Never uses localStorage for tokens.
 */
export class SessionMemory {
  private memory: MiaSession | null = null;

  save(session: MiaSession, persist = true): void {
    this.memory = session;
    if (!persist || typeof sessionStorage === 'undefined') return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify(session));
    } catch {
      // ignore quota / private mode
    }
  }

  load(): MiaSession | null {
    if (this.memory) return this.memory;
    if (typeof sessionStorage === 'undefined') return null;
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as MiaSession;
      if (!parsed?.sessionToken || !parsed?.expiresAt) return null;
      this.memory = parsed;
      return parsed;
    } catch {
      return null;
    }
  }

  clear(): void {
    this.memory = null;
    if (typeof sessionStorage === 'undefined') return;
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  }

  isExpired(session: MiaSession, skewMs = 30_000): boolean {
    const exp = Date.parse(session.expiresAt);
    if (Number.isNaN(exp)) return true;
    return Date.now() >= exp - skewMs;
  }
}
